import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";


import 'react-tabs/style/react-tabs.css';

import * as PD from '../classes/pdStyle';

import {cloneObject, getParam} from '../utils/utils';

import Buffering from "../components/Buffering"; 

import dsd from "../classes/clsDSD";

import { addLink, editLink, getLink, getConceptModel } from "../utils/utilsConceptModel";

import SelectConcept from "../components/SelectConcept";

import D3Graphviz from "../components/D3Graphviz";
import ViewLink from "../components/ViewLink";
import ViewConceptModel from "../components/ViewConceptModel";
import ViewMetadata from "../components/ViewMetadata";

import Rendition from '../components/Rendition';

import { DesignerLayoutContext } from '../contexts/DesignerLayoutContext';
import { Select } from "semantic-ui-react";

import Revision from "../components/Revision"
import ListRevisions from "../components/ListRevisions"


class Link extends React.Component {

    static contextType = DesignerLayoutContext;

    constructor(props) {
        super(props);
        this.state = {
            mode: 'view',
            renderState: null
        };


        this.data = {};


        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleMode = this.handleMode.bind(this);
        this.handleButton = this.handleButton.bind(this);
        this.handleVizClick = this.handleVizClick.bind(this);

        this.refRevision = React.createRef();
        this.loadedRevisions = this.loadedRevisions.bind(this);

        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.FallBackNavigation = `/`;

    }

    componentDidMount(){

       this.setup();

    }

    componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
    
    loadConceptModel(id){

        let StateChange = {};
        StateChange.ConceptModel = null;

        const onLoad = function(data){
            let StateChange = {};
            StateChange.ConceptModel = data;
            
            // Only set FormData for new mode - just default Link values
            if (this.state.mode === 'new'){
                StateChange.FormData = {
                    status: 'in use'
                };
            }

            StateChange.renderState = "loaded";

            StateChange.OfferEdit = false;
            try{
                if (this.dsd.loggedon){
                    if (data.idUser == this.dsd.user.id){
                        StateChange.OfferEdit = true;
                    }
                }
            }
            catch{

            }   

            if (!StateChange.OfferEdit){
                switch (this.state.mode){
                    case "new":
                    case "edit":
                    case "remove":
                        StateChange.renderState = "denied";
                        StateChange.errorMessage = "You cannot add or edit Links to this Concept Model";
                    break;
                }
            }

            this.setState(StateChange);
            return;
        }.bind(this);

        const onFail = function(e){
            let StateChange = {};
            StateChange.ConceptModel = null;
            StateChange.renderState = "failed";

            StateChange.errorMessage = e.message;    
            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                }
            }
            this.setState(StateChange);
            return;
        }.bind(this);

        if (id){
            StateChange.renderState = "loading";
            getConceptModel(this.dsd, id, onLoad, onFail);
        }

        this.setState(StateChange);

        return;
        
    };

    loadLink(id){

        let StateChange = {};
        StateChange.Link = null;

        const onLoad = function(data){
            let StateChange = {};
            StateChange.Link = data;
            StateChange.ConceptModel = data.ConceptModel;
            StateChange.FormData = data;

            StateChange.renderState = "loaded";

            if (data.ConceptModel){
                StateChange.ConceptModel = data.ConceptModel;
                if (this.context.hasLayout){
                    this.context.Layout.setLeftAsConceptModel(data.ConceptModel._id);
                }
            }


            StateChange.OfferEdit = false;
            try{
                if (this.dsd.loggedon){
                    if (data.ConceptModel && data.ConceptModel.idUser == this.dsd.user.id){
                        StateChange.OfferEdit = true;
                    }
                }
            }
            catch{

            }   

            if (!StateChange.OfferEdit){
                switch (this.state.mode){
                    case "edit":
                    case "remove":
                        StateChange.renderState = "denied";
                        StateChange.errorMessage = "You cannot edit this Link";
                    break;
                }
            }

            this.fetchViz(id);

            this.setState(StateChange);

            return;
        }.bind(this);

        const onFail = function(e){
            let StateChange = {};
            StateChange.Link = null;
            StateChange.renderState = "failed";

            StateChange.errorMessage = e.message;    
            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                }
            }
            this.setState(StateChange);
            return;
        }.bind(this);

        if (id){
            StateChange.renderState = "loading";
            getLink(this.dsd, id, onLoad, onFail);
        }

        this.setState(StateChange);

        return;
        
    };

    fetchViz(id) {

        const onDoneDot = function(dot) {
            this.setState({ dot: dot });
        }.bind(this);

        const onFailDot = function(error) {
            console.error('Failed to fetch DOT:', error);
        }.bind(this);

        getLink(this.dsd, id, onDoneDot, onFailDot, 'dot', null, this.state.Controls);

    };
    

    setup(){

        let StateChange = {

            mode: "view",

            idLink: null,
            idConceptModel: null,

            ConceptModel: null,
            Link: null,

            isUpdated: false,

            isFailed: false,
            isError: false,
            errorMessage: null,

            renderState: null,

            FormData: {
                status:'in use'
            },

            OfferEdit:false,

            Controls: {
            },

            countRevisions: null,

            dot:null


        }

        if (getParam('mode', this.props)){
            StateChange.mode = getParam('mode', this.props);
        }
        StateChange.idLink = getParam('id', this.props);
        StateChange.idConceptModel = getParam('idConceptModel', this.props);

        switch (StateChange.mode){
            case 'new':
                if (!StateChange.idConceptModel){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Concept Model not specified when adding a Link"
                }
                break;
            default:
                if (StateChange.idConceptModel){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Concept Model should not be specified for an existing Link"
                }
                if (!StateChange.idLink){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Concept not be specified for an existing Link"
                }
                break;
        }

        if (StateChange.mode == "new"){
            if (StateChange.idConceptModel){
                this.FallBackNavigation = `/conceptmodel/${StateChange.idConceptModel}`;
            }        
        }

        if (StateChange.idConceptModel){
            this.loadConceptModel(StateChange.idConceptModel);
        }
        if (StateChange.idLink){
            this.loadLink(StateChange.idLink);
        }

        if (StateChange.mode == null){
            StateChange.mode = 'view';
        }

        this.setState(StateChange);
        
    }

    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        switch (FormFieldName){
            default:
                let FormData = this.state.FormData;
                FormData[FormFieldName] = FormFieldValue;        
                this.setState({"FormData": FormData});
                break;                
        }
        return;

    };
    
    handleSubmit(event) {

        window.scrollTo(0, 0);

        switch (event.target.name){
            
            case 'btnCancel':

                this.setState({
                    renderState: "cancelled"
                })

                switch (this.state.mode){
                    case "edit":
                        this.props.navigation(`/link/${this.state.idLink}`);
                        break;
                    case "new":
                        this.props.navigation(this.FallBackNavigation);
                        break;
                }

                break;
            case 'btnSave':
            default:

                this.setState({
                    renderState: "updating"
                })

                const onAdd = function(idLink){
                    this.props.navigation(`/link/${idLink}`);
                    return;
                }.bind(this);

                const onUpdate = function(){
                    this.props.navigation(`/link/${this.state.idLink}`);
                    return;
                }.bind(this);

                const onError = function(e){
                    let StateChange = {};
                    StateChange.renderState = "error";
                    
                    StateChange.errorMessage = e.message;
                    if (e.response){
                        if (e.response.data){
                            if (e.response.data.message){
                                StateChange.errorMessage = e.response.data.message;
                            }
                        }
                    }
                    
                    this.setState(StateChange);
                }.bind(this);
        
                switch (this.state.mode){
                    case 'new':
                        addLink(this.dsd, this.state.idConceptModel, this.state.FormData, onAdd, onError);
                        break;
                    case 'edit':
                        editLink(this.dsd, this.state.ConceptModel._id, this.state.idLink, this.state.FormData, onUpdate, onError);
                        this.refRevision.current.update();
                        break;
                    default:
                        break; 
                };
    
        };

        event.preventDefault();
    }

    handleMode(event) {
        this.setState({mode: event.target.value});
        event.preventDefault();
    }


    handleButton(event) {

        let StateChange = {};

        switch (event.target.name){
        }

        this.setState(StateChange);

        event.preventDefault();
    };

    handleVizClick(event) {

        let StateChange = {};

        let idNode = null;

        let target = null;
        if (event.target.tagName == "a"){
            target = event.target;
        } else{
            if ("parentElement" in event.target){
                if (event.target.parentElement.tagName == "a"){
                    target = event.target.parentElement;
                }
            }
        }

        if (target){
            if ("href" in target){
                idNode = target.href.baseVal;
                StateChange.vizNodeId = idNode;
            }
        }
        

        if (!idNode){
            return;
        }
        
        let partsVizNodeId = idNode.split('_');
        switch(partsVizNodeId[0]){
            case 'concept':
                if (partsVizNodeId.length > 1){
                    this.props.navigation(`/concept/${partsVizNodeId[1]}`);
                }
                break;
        }

        this.setState(StateChange);

        event.preventDefault();

    };

    loadedRevisions(count) {

        let StateChange = {};

        StateChange.countRevisions = 0;
        if (count){
            StateChange.countRevisions = count;
        }

        this.setState(StateChange);


    };


    visualise(){
    
        if (!this.state.Link){
            return null;
        }

        try {

            return(
                <div>
                    <div name="divViz" onClick={this.handleVizClick}>
                        <D3Graphviz dot={this.state.dot}/>
                    </div>

                </div>
            );
          } catch (error) {
            return <div/>
          }
    };


    render() {

        switch (this.state.renderState){
            case "invalid":
            case "failed":
            case "denied":
                let Message = "An error has occured";
                if (this.state.errorMessage){
                    Message = this.state.errorMessage;
                }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>
                break;
            case "loading":
                return <Buffering/>
                break;
            case "cancelled":
                return <p>Cancelled</p>
                break;
    
        }



        switch (this.state.mode){
            case 'new':
            case 'edit':

                switch (this.state.renderState){
                    case "loaded":
                    case "updating":
                    case "error":

                        return (
                            <div>

                                <PD.Heading>{this.state.mode} Link</PD.Heading>

                                {this.state.renderState == "error" &&
                                    <PD.ErrorBox>
                                        ERROR - Failed to Update
                                        {this.state.errorMessage && <><br/>{this.state.errorMessage}</>}
                                    </PD.ErrorBox>
                                }

                                <form> 

                                    <fieldset>
                                        <legend>Select the FROM Concept</legend>
                                        <SelectConcept  selectConceptModel={true} idConceptModel={this.state.idConceptModel} label='Concept' name='idConceptFrom' value={this.state.FormData.idConceptFrom} onChange={this.handleChange}/>
                                    </fieldset>


                                    <fieldset>
                                        <legend>Select the TO Concept</legend>
                                        <SelectConcept  selectConceptModel={true} idConceptModel={this.state.idConceptModel} label='Concept' name='idConceptTo' value={this.state.FormData.idConceptTo} onChange={this.handleChange}/>
                                    </fieldset>

                                    <PD.Input label="Name" width="60" name="name" value={this.state.FormData.name} onChange={this.handleChange}/>
                                    <PD.Input label="Label" width="60" name="label" value={this.state.FormData.label} onChange={this.handleChange}/>
                                    <PD.Input label="Inverse Label" width="60" name="inverseLabel" value={this.state.FormData.inverseLabel} onChange={this.handleChange}/>

                                    <PD.Editor name="description" label='Description' value={this.state.FormData.description} onChange={this.handleChange}/>
                                    <PD.Editor name="notes" label='Notes' value={this.state.FormData.notes} onChange={this.handleChange}/>
                                    <PD.Editor name="proposals" label='Proposals' value={this.state.FormData.proposals} onChange={this.handleChange}/>

                                    <PD.Select label="Status" name='status'  onChange={this.handleChange} value={this.state.FormData.status}>
                                        {
                                            this.dsd.config.LinkStatuses.map(
                                                (status, posStatus) => 
                                                    {
                                                        return(
                                                            <option key={posStatus} value={status}>{status}</option>
                                                        )
                                                    }
                                            )
                                        }
                                    </PD.Select>

                                    <Revision ref={this.refRevision}  idAbout={this.state.idLink}/>

                                    
                                    {(() => {
                                        switch (this.state.renderState) {
                                            case "updating":
                                                return (
                                                    <div>
                                                        <PD.Button disabled={true} type="submit" name="btnSave">
                                                            <Buffering/>
                                                        </PD.Button>
                                                    </div>
                                                )
                                            default:
                                                return (
                                                    <div>
                                                        <PD.Button type="submit" onClick={this.handleSubmit} name="btnSave" value="Save" />    
                                                        <PD.Button type="warning" onClick={this.handleSubmit} name="btnCancel" value="Cancel" /> 
                                                    </div>
                                                )
                                        }
                                    })()}

                                </form>

                            </div>    
                        );
                }
                break;
            case 'remove':
                return (
                    <div>
                        <PD.Heading>{this.state.mode} Link</PD.Heading>

                        {this.state.renderState == "error" &&
                            <PD.ErrorBox>
                                ERROR - Failed to Update
                                {this.state.errorMessage && <><br/>{this.state.errorMessage}</>}
                            </PD.ErrorBox>
                        }

                        <PD.Button onClick={this.handleSubmit} type="warning" value="confirm remove?" />
                        <ViewLink Link={this.state.Link}/>
                    </div>
                )
            case 'view':
            default:
                
                switch (this.state.renderState){
                    case "loaded":

                        return (
                            <div>
                                <div>
                                    <PD.Breadcrumb crumbs={this.Breadcrumb}/>
                                    <PD.Heading>Link:{this.state.Link.name}</PD.Heading>
                                </div>

                                {this.state.OfferEdit &&
                                    <span style={{paddingRight:10}}>
                                            <PD.Button onClick={this.handleMode} type="submit" value="edit" />                        
                                    </span>
                                }

                                <ViewLink Link={this.state.Link}/>

                                <br/>

                                <PD.Tabs>


                                    <div label='Visualise'>
                                        {this.visualise()}
                                    </div>


                                    <div label='Concept Model'>
                                        <ViewConceptModel ConceptModel={this.state.ConceptModel} />
                                    </div>


                                    <div label='Metadata'>
                                        <ViewMetadata Data={this.state.Link} />
                                    </div>

                                    <div label={<span>Revisions({this.state.countRevisions === null ? <Buffering/> : this.state.countRevisions})</span>} data-forcerender="true">
                                        <ListRevisions OfferEdit={this.state.OfferEdit} filters={{idAbout:this.state.idLink}} onLoad={this.loadedRevisions}/>
                                    </div>

                                    <div label='Developer'>
                                        <Rendition
                                            endpoint="/links"
                                            id={this.state.idLink}
                                        />
                                    </div>

                                </PD.Tabs>


                            </div>
                        )
                }
        };

        return <div />;
    };
};

// Wrap and export
export default function Link_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <Link {...props} navigation={navigation} location={location} params={params} />;
  }
